import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { can } from '@/utils/perms';
import { BRAND } from '@/brand';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
  /** Optional role-gated section; if the admin's role can't access it, redirect to the admin home. */
  section?: string;
}

export default function AdminProtectedRoute({ children, section }: AdminProtectedRouteProps) {
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const location = useLocation();

  useEffect(() => {
    try {
      const adminStr = localStorage.getItem('adminUser');
      const isAdminFlag = localStorage.getItem('isAdmin');

      if (adminStr && isAdminFlag === 'true') {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }
    } catch (error) {
      setIsAdmin(false);
    }
  }, []);

  if (isAdmin === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking admin access...</p>
        </div>
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to="/admin-login" state={{ from: location }} replace />;
  }

  // Role-based section gate: send disallowed admins back to their home.
  if (section && !can(section)) {
    return <Navigate to={BRAND === 'corporate' ? '/admin/accounting' : '/admin'} replace />;
  }

  return <>{children}</>;
}
